import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { computed, useRoute } from '@nuxtjs/composition-api'
import { IProduct } from '@entites/menu/model/types'
import { useCustomLogicModel } from '@shared/model'
import { ButtonWithIcon } from '@shared/ui'
import { useMenuModel } from '@entities/menu'
import { useRestaurantModel } from '@entities/restaurant'
import { useCallWaiterModel } from '@entities/call-waiter'
import { useOrderModel } from '@entities/order'
import { isCartDisabledForTable } from '@entities/restaurant/utils/cartRules'
import { isOrderButtonHiddenForTable } from '@entities/restaurant/utils/footerRules'


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
  menuFooter: {
    type: String as PropType<string>,
    default: '',
    required: true
  },
  totalSum: {
    type: String as PropType<string>,
    required: false,
    default: '0'
  },
  currencyIcon: {
    type: String as PropType<string>,
    required: false,
    default: ''
  },
  description: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: true
  }
},
  emits: ['footerHandler'],
  setup(__props, { emit: emits }) {

const props = __props

const customLogicModel = useCustomLogicModel()
const menuModel = useMenuModel()
const restaurantModel = useRestaurantModel()
const CallWaiterModel = useCallWaiterModel()
const orderModel = useOrderModel()
const route = useRoute()





const totalItemCart = computed(() => {
  if (menuModel.cart.length) {
    const total = menuModel.cart.reduce((acc: number, item: IProduct) => {
      acc = acc + item.inCart
      return acc
    }, 0)
    return total
  } else {
    return 0
  }
})

const sumTotalSum = computed(() => {
  return parseFloat(props.totalSum).toFixed(2)
})

const tableId = computed(() => restaurantModel.tableCode || route.value.params.id)
const isCartButtonVisible = computed(() => {
  const isDisabled = isCartDisabledForTable(restaurantModel.code, tableId.value)
  return restaurantModel.isCartEnabled && menuModel.menuUser.length && !isDisabled
})

const isOrderButtonVisible = computed(() => {
  return !isOrderButtonHiddenForTable(restaurantModel.code, tableId.value)
})


return { __sfc: true,customLogicModel, menuModel, restaurantModel, CallWaiterModel, orderModel, route, emits, props, totalItemCart, sumTotalSum, tableId, isCartButtonVisible, isOrderButtonVisible, ButtonWithIcon }
}

})